// API Configuration
// Centralized API base URL configuration for the entire application

const API_BASE_URL = 'https://vasstrinfo.com';

export default API_BASE_URL;
